import { useCallback, useState } from "preact/hooks";
import axios from "axios";


export default function useAxiosCallback() {

    const [isLoading, setIsLoading] = useState(false);

    const onAxiosRequest = () => setIsLoading(false);

    const setAxiosRequest = useCallback((url, config, onSuccessCallback, onErrorCallback) => {
        setIsLoading(true);
        return axios(url, config).then(onSuccessCallback).catch(onErrorCallback).finally(onAxiosRequest);
    }, []);

    return { isLoading, fetch: setAxiosRequest };
}